import Drawer from 'devextreme-react/drawer';
import SideMenu from './side-menu/side-menu';
import './side-nav.scss';
import { useCustomerPortalGlobalStore } from '../../../stores/customer-portal-global-store';

const SideNav = () => {
  const [isSideNavOpened] = useCustomerPortalGlobalStore<boolean>(
    store => store.menu.isSideNavOpened
  );

  return (
    <>
      <div className="drawer-div main-side-menu">
        <Drawer
          className={`${isSideNavOpened ? '' : 'side-menu-collapse'}`}
          opened={!!isSideNavOpened}
          openedStateMode="shrink"
          position="left"
          revealMode="slide"
          closeOnOutsideClick={false}
          render={() => <SideMenu />}
        >
          <div></div>
        </Drawer>
      </div>
    </>
  );
};

export default SideNav;
